import {Controller} from "@/controllers/Controller";

/**
 * Controller for disbursement API (ms-purchase)
 */
export class DisbursementController extends Controller {

    // Décaissements enrichis (fournisseur et achat), avec filtres, tris et pagination
    static getTable(urlParams = "") {
        return this.requestBuilder("GET", `/purchase/disbursements/table${urlParams}`, true);
    }

    static getByPurchase(purchaseId) {
        return this.requestBuilder("GET", `/purchase/disbursements/by-purchase/${purchaseId}`, true);
    }

    static getBySupplier(supplierId) {
        return this.requestBuilder("GET", `/purchase/disbursements/by-supplier/${supplierId}`, true);
    }

    static post(body) {
        return this.requestBuilder("POST", `/purchase/disbursements`, true, body);
    }

    static patch(id, body) {
        return this.requestBuilder("PATCH", `/purchase/disbursements/${id}`, true, body);
    }

    static delete(id) {
        return this.requestBuilder("PATCH", `/purchase/disbursements/deactivate/${id}`, true);
    }
}
